import React, { useState } from 'react';
import SolarPVDiagram from '../components/sld/SolarPVDiagram';
import {
  Box,
  Paper,
  Stack,
  Typography,
  Grid,
  TextField,
  Button,
  useTheme,
  useMediaQuery,
  Divider,
} from '@mui/material';

const SLD = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const materials = useState(() => {
    try {
      const raw = localStorage.getItem('materialsData');
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      console.error('Failed to parse materialsData from localStorage', e);
      return [];
    }
  });

  const handlePrint = () => {
    window.print();
  };
  const [selectedComponent, setSelectedComponent] = useState({
    name: 'PV Array',
    position: [-18 - 8, 8, 0],
    size: [6, 3, 0.2],
    color: '#1e3a8a',
    details: {
      Brand_name: '',
      Specification: '',
      Quantity: '',
    },
  });

  const handleSaveDetails = (updatedComponent) => {
    console.log('Updated component:', updatedComponent);
    alert(`${updatedComponent.name} details saved!`);
  };

  return (
    <Box sx={{ height: '100vh', width: '100%', overflow: 'auto', p: 2 }}>
      <Typography variant='h5' sx={{ fontWeight: 700, mb: 2 }}>
        Single Line Diagram (SLD)
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} md={9}>
          <Box
            sx={{
              flex: 3,
              borderRadius: '9px',
              height: '80vh',
              overflow: 'hidden',
              width: '100%',
            }}
          >
            <SolarPVDiagram
              onSelectComponent={setSelectedComponent}
              materials={materials}
            />
          </Box>
        </Grid>

        <Grid item xs={12} md={3}>
          <Paper
            elevation={1}
            sx={{
              p: 2,
              borderRadius: 2,
              border: '1px solid lightgray',
              overflowY: 'auto',
              backgroundColor: 'transparent',
              // height: '80vh',
            }}
          >
            <Stack spacing={2}>
              <Typography
                variant='subtitle1'
                sx={{ fontWeight: 600, textAlign: 'center' }}
              >
                Configuration
              </Typography>

              {selectedComponent ? (
                <>
                  <Typography
                    variant='h6'
                    sx={{ fontWeight: 600, color: '#2D3E50' }}
                  >
                    {selectedComponent.name}
                  </Typography>

                  {Object.entries(selectedComponent.details).map(
                    ([key, value]) => (
                      <TextField
                        key={key}
                        fullWidth
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        size='small'
                        value={value}
                        type={key === 'Quantity' ? 'number' : 'text'}
                        onChange={(e) =>
                          setSelectedComponent({
                            ...selectedComponent,
                            details: {
                              ...selectedComponent.details,
                              [key]: e.target.value,
                            },
                          })
                        }
                      />
                    ),
                  )}

                  <Divider />

                  {/* <Button
                    variant='contained'
                    onClick={() => {
                      handleSaveDetails(selectedComponent);
                      handlePrint();
                    }}
                    sx={{
                      width: 'fit-content',
                      borderRadius: '32px',
                      backgroundColor: '#A8D5A8',
                      color: '#000',
                      fontWeight: 'bold',
                      textTransform: 'none',
                      '&:hover': { backgroundColor: '#91c291' },
                    }}
                  >
                    Save Changes
                  </Button> */}
                </>
              ) : (
                <Typography
                  variant='body2'
                  sx={{ color: 'gray', textAlign: 'center' }}
                >
                  Select a component from the diagram to edit details
                </Typography>
              )}
            </Stack>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SLD;
